<div class="time-frame-btn-container" [ngClass]="isRightPosition ? 'ms-auto' : 'me-auto'">
  <mat-button-toggle-group [ngModel]="timeFrameMode" (ngModelChange)="onTimeFrameChange($event)" [ngModelOptions]="{ standalone: true }" class="button-style">
    <mat-button-toggle value="year">Annual</mat-button-toggle>
    <mat-button-toggle value="quarter">Quarterly</mat-button-toggle>
  </mat-button-toggle-group>
</div>
